import React from 'react';
import { Form, Input, Button, Row, Col, message, Card } from 'antd';
import axios from 'axios';
import { createTenant } from '../../services/tenantApi';
import { toast } from 'react-toastify';

const CreateTenant = () => {
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      let res = await createTenant(values)
     if(res?.message) toast.success('Created sucessfully!')
    else return toast.error('something went wrong!')
      form.resetFields();
    } catch (err) {
      message.error(err.response?.data?.error || 'Failed to create tenant');
    }
  };

  return (
    <Card title="Create Tenant" style={{ maxWidth: 800, margin: 'auto' }}>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Owner Name"
              name="ownerName"
              rules={[{ required: true, message: 'Please enter owner name' }]}
            >
              <Input placeholder="Enter owner's full name" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Tenant Name"
              name="tenantName"
              rules={[{ required: true, message: 'Please enter tenant name' }]}
            >
              <Input placeholder="Enter tenant/company name" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Email"
              name="email"
              rules={[
                { required: true, message: 'Please enter email' },
                { type: 'email', message: 'Enter a valid email' },
              ]}
            >
              <Input placeholder="Enter email address" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12}>
            <Form.Item
              label="Contact Number"
              name="number"
              rules={[{ required: true, message: 'Please enter phone number' }]}
            >
              <Input placeholder="Enter contact number" />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Create Brand
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
};

export default CreateTenant;
